export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";